import { Link, LinkProps, styled } from '@mui/material';

import type { MouseEvent } from 'react';

type Props = LinkProps & { href: string };

const CaseLink = styled(Link)(({ theme: { utils, spacing } }) => ({
  marginLeft: spacing(1),
  fontSize: utils.clamp(16, 24),
}));

export const ExternalCaseLink = ({ href, children, ...rest }: Props) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Always prevent default and force system browser
    e.preventDefault();

    // In installed PWA mode, ensure system browser opens
    if (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window.navigator as any).standalone ||
      window.matchMedia('(display-mode: standalone)').matches
    ) {
      window.open(href, '_blank'); // Forces external browser
    } else {
      // Normal behavior in browser
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <CaseLink href={href} onClick={handleClick} {...rest}>
      {children}
    </CaseLink>
  );
};
